/**
 * devOnlyGuard — `CanActivateFn` that blocks dev/tooling-only routes in a
 * production build (PRO-426).
 *
 * RESPONSIBILITY: surfaces like the admin Brand Test are engineering tools,
 * not customer features. Rail visibility already hides them, but a direct URL
 * hit (`/platform/brand-test`, bookmark, paste) would still resolve in a
 * production bundle. Pair `canActivate: [devOnlyGuard]` on those routes so a
 * production visitor falls through to Overview exactly as they would for any
 * non-existent admin URL, while dev/local builds keep the tools reachable.
 *
 * SEMANTICS:
 *   • Non-production (`!environment.production`) → always allowed.
 *   • Production → redirect to `/admin/overview` (never reveal the route by
 *     erroring differently from a normal miss).
 */
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

export const devOnlyGuard: CanActivateFn = () => {
  if (!environment.production) return true;
  return inject(Router).createUrlTree(['/overview']);
};
